import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { sortByKey } from "../../utils/string";

export default function useProgressReport() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const mapped = res.data.questionsCompleteStats.map((item) => ({
        Subject: item._id.name,
        Attempted: item.completed,
        Pending: item.pending,
      }));
      setData(sortByKey(mapped,"Subject"));
    }
  };

  return { data, loading, fetchData };
}